export default __webpack_public_path__ + "static/media/edged.58193721.png";